import { JSONSchema7 } from "json-schema";

export const RemindRateAppMetadataSettingSchema: JSONSchema7 = {
  type: "object",
  $schema: "http://json-schema.org/draft-07/schema#",
};
